import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e035
 * @category 점검계획등록
 */
export default class PlanModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 현장
   *
   * **data type** varchar(8)
   */
  readonly actcd: string;

  /**
   * 현장명
   *
   * **data type** varchar(8)
   */
  readonly actnm: string;

  /**
   * 담당자 전화번호
   *
   * **data type** varchar(8)
   */
  readonly actperhp: string;

  /**
   * 담당자
   *
   * **data type** varchar(8)
   */
  readonly actpernm: string;

  /**
   * 전 계획일
   *
   * **data type** varchar(8)
   */
  readonly beplandate: string;

  /**
   * 거래처
   *
   * **data type** varchar(8)
   */
  readonly cltcd: string;

  /**
   * 호기
   *
   * **data type** varchar(8)
   */
  readonly equpcd: string;

  /**
   * 호기명
   *
   * **data type** varchar(8)
   */
  readonly equpnm: string;

  /**
   * 점검기종
   *
   * **data type** varchar(8)
   */
  readonly evcd: string;

  /**
   * 구분
   *
   * **data type** varchar(8)
   */
  readonly gubun: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  readonly indate: string;

  /**
   * 입력자
   *
   * **data type** varchar(8)
   */
  readonly inperid: string;

  /**
   * 처리자
   *
   * **data type** varchar(8)
   */
  readonly kcperid: string;

  /**
   * 처리자2
   *
   * **data type** varchar(8)
   */
  readonly kcperid2: string;

  /**
   * 처리자명
   *
   * **data type** varchar(8)
   */
  readonly kcpernm: string;

  /**
   *처리자명2
   *
   * **data type** varchar(8)
   */
  readonly kcpernm2: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  readonly kcspnm: string;

  /**
   * 조속기
   *
   * **data type** varchar(8)
   */
  readonly part_nm1: string;

  /**
   * 로프브레이크
   *
   * **data type** varchar(8)
   */
  readonly part_nm2: string;

  /**
   * 도어잠금장치
   *
   * **data type** varchar(8)
   */
  readonly part_nm3: string;

  /**
   * 비상정지장치
   *
   * **data type** varchar(8)
   */
  readonly part_nm4: string;

  /**
   * 완충기
   *
   * **data type** varchar(8)
   */
  readonly part_nm5: string;

  /**
   * 역구동방지장치
   *
   * **data type** varchar(8)
   */
  readonly part_nm6: string;

  /**
   * 기판(제어판
   *
   * **data type** varchar(8)
   */
  readonly part_nm7: string;

  /**
   * EL 제동기
   *
   * **data type** varchar(8)
   */
  readonly part_nm8: string;

  /**
   * 와이어로프
   *
   * **data type** varchar(8)
   */
  readonly part_nm9: string;

  /**
   * 리미트스위치
   *
   * **data type** varchar(8)
   */
  readonly part_nm10: string;

  /**
   * 럽쳐밸브
   *
   * **data type** varchar(8)
   */
  readonly part_nm11: string;

  /**
   * 스텝
   *
   * **data type** varchar(8)
   */
  readonly part_nm12: string;

  /**
   * 스텝체인
   *
   * **data type** varchar(8)
   */
  readonly part_nm13: string;

  /**
   * ES 제동기
   *
   * **data type** varchar(8)
   */
  readonly part_nm14: string;

  /**
   * 담당자
   *
   * **data type** varchar(8)
   */
  readonly perid: string;

  /**
   * 담당자2
   *
   * **data type** varchar(8)
   */
  readonly perid2: string;

  /**
   * 담당자명
   *
   * **data type** varchar(8)
   */
  readonly pernm: string;

  /**
   * 담당자명2
   *
   * **data type** varchar(8)
   */
  readonly pernm2: string;

  /**
   * 계획일
   *
   * **data type** varchar(8)
   */
  readonly plandate: string;

  /**
   * 계획구분
   *
   * **data type** varchar(8)
   */
  readonly plangubun: string;

  /**
   * 계획월
   *
   * **data type** varchar(8)
   */
  readonly planmon: string;

  /**
   * 점검시간
   *
   * **data type** varchar(8)
   */
  readonly plantime: string;

  /**
   * 완료시간
   *
   * **data type** varchar(8)
   */
  readonly plantime2: string;

  /**
   * 비고
   *
   * **data type** varchar(8)
   */
  readonly remark: string;

  /**
   * 결과
   *
   * **data type** varchar(8)
   */
  readonly result: string;

  /**
   * 처리일
   *
   * **data type** varchar(8)
   */
  readonly rptdate: string;

  /**
   * 사업자코드
   *
   * **data type** varchar(8)
   */
  readonly spjangcd: string;

  /**
   * 상태
   *
   * **data type** varchar(8)
   */
  readonly state: string;

  /**
   * 계약구분
   *
   * **data type** varchar(8)
   */
  readonly contg: string;

  /**
   * 만료일
   *
   * **data type** varchar(8)
   */
  readonly enddate: string;

  /**
   * 계약구분
   *
   * **data type** varchar(8)
   */
  readonly state_contg: string;

  /**
   * 선택
   *
   * **data type** varchar(8)
   */
  chk: string;

  /**
   * 신규 유무
   *
   * **data type** varchar(1)
   */
  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.actperhp = data.actperhp || '';
    this.actpernm = data.actpernm || '';
    this.beplandate = data.beplandate || '';
    this.cltcd = data.cltcd || '';
    this.equpcd = data.equpcd || '';
    this.equpnm = data.equpnm || '';
    this.evcd = data.evcd || '';
    this.gubun = data.gubun || '002';
    this.indate = data.indate || '';
    this.inperid = data.inperid || '';
    this.kcperid = data.kcperid || '';
    this.kcperid2 = data.kcperid2 || '';
    this.kcpernm = data.kcpernm || '';
    this.kcpernm2 = data.kcpernm2 || '';
    this.kcspnm = data.kcspnm || '';
    this.part_nm1 = data.part_nm1 || 'N';
    this.part_nm2 = data.part_nm2 || 'N';
    this.part_nm3 = data.part_nm3 || 'N';
    this.part_nm4 = data.part_nm4 || 'N';
    this.part_nm5 = data.part_nm5 || 'N';
    this.part_nm6 = data.part_nm6 || 'N';
    this.part_nm7 = data.part_nm7 || 'N';
    this.part_nm8 = data.part_nm8 || 'N';
    this.part_nm9 = data.part_nm9 || 'N';
    this.part_nm10 = data.part_nm10 || 'N';
    this.part_nm11 = data.part_nm11 || 'N';
    this.part_nm12 = data.part_nm12 || 'N';
    this.part_nm13 = data.part_nm13 || 'N';
    this.part_nm14 = data.part_nm14 || 'N';
    this.perid = data.perid || '';
    this.perid2 = data.perid2 || '';
    this.pernm = data.pernm || '';
    this.pernm2 = data.pernm2 || '';
    this.plandate = data.plandate || '';
    this.plangubun = data.plangubun || '1';
    this.planmon = data.planmon || '';
    this.plantime = data.plantime || '';
    this.plantime2 = data.plantime2 || '';
    this.remark = data.remark || '';
    this.result = data.result || '';
    this.rptdate = data.rptdate || '';
    this.spjangcd = data.spjangcd || '';
    this.state = data.state || '';
    this.contg = data.contg || '';
    this.enddate = data.enddate || '';
    this.state_contg = data.state_contg || '';
    this.chk = data.chk || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
